'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemMatchesStatusFilter = exports.itemMatchesMaterialTypeFilter = exports.getCountsByStatusFromSummary = exports.getTotalCountFromSummary = exports.getTotalFromMaterialTypeCounts = exports.getMaterialTypeCountsForStatus = exports.getTotalMaterialTypeCounts = exports.getPresentStatusesFromSummary = undefined;

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPresentStatusesFromSummary = exports.getPresentStatusesFromSummary = function getPresentStatusesFromSummary(borrowingSummary) {
  return borrowingSummary.get('status', _immutable2.default.Map()).filter(function (materialTypeCounts) {
    return materialTypeCounts.get('DIGITAL', 0) > 0 || materialTypeCounts.get('PHYSICAL', 0) > 0;
  }).keySeq().toList();
};

var getTotalMaterialTypeCounts = exports.getTotalMaterialTypeCounts = function getTotalMaterialTypeCounts(borrowingSummary) {
  return borrowingSummary.get('status', _immutable2.default.Map()).reduce(function (totalCount, countForStatus) {
    return totalCount.set('PHYSICAL', totalCount.get('PHYSICAL', 0) + countForStatus.get('PHYSICAL', 0)).set('DIGITAL', totalCount.get('DIGITAL', 0) + countForStatus.get('DIGITAL', 0));
  }, _immutable2.default.Map().asMutable()).asImmutable();
};

var getMaterialTypeCountsForStatus = exports.getMaterialTypeCountsForStatus = function getMaterialTypeCountsForStatus(borrowingSummary, status) {
  if (status) {
    return borrowingSummary.getIn(['status', status.toUpperCase()], _immutable2.default.Map({
      PHYSICAL: 0,
      DIGITAL: 0
    }));
  }

  return getTotalMaterialTypeCounts(borrowingSummary);
};

var getTotalFromMaterialTypeCounts = exports.getTotalFromMaterialTypeCounts = function getTotalFromMaterialTypeCounts(countsByMaterialType) {
  return countsByMaterialType.get('DIGITAL', 0) + countsByMaterialType.get('PHYSICAL', 0);
};

var getTotalCountFromSummary = exports.getTotalCountFromSummary = function getTotalCountFromSummary(borrowingSummary) {
  return borrowingSummary.get('status', _immutable2.default.Map()).reduce(function (acc, countsByMaterialType) {
    return acc + getTotalFromMaterialTypeCounts(countsByMaterialType);
  }, 0);
};

var getCountsByStatusFromSummary = exports.getCountsByStatusFromSummary = function getCountsByStatusFromSummary(borrowingSummary) {
  return borrowingSummary.get('status', _immutable2.default.Map()).map(function (countsByMaterialType) {
    return getTotalFromMaterialTypeCounts(countsByMaterialType);
  });
};

var itemMatchesMaterialTypeFilter = exports.itemMatchesMaterialTypeFilter = function itemMatchesMaterialTypeFilter(item, materialType) {
  return !materialType || materialType.toUpperCase() === item.getIn(['bib', 'policy', 'materialType']);
};

var itemMatchesStatusFilter = exports.itemMatchesStatusFilter = function itemMatchesStatusFilter(item, status) {
  return !status || status.toUpperCase() === item.get('status').toUpperCase();
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-borrowing/lib/index.js
// module id = 230
// module chunks = 1